import BigNumber from 'bignumber.js';
import { createJSONStorage } from 'zustand/middleware';

export const createBigNumberStorage = <T>() => {
  return createJSONStorage<T>(() => localStorage, {
    reviver: (key, value) => {
      if (
        value &&
        typeof value === 'object' &&
        '__type' in value &&
        value.__type === 'BigNumber'
      ) {
        return new BigNumber((value as any).value); // Restore BigNumber
      }

      return value;
    },
    // should not use arrow function here to avoid capturing `this` from lexical scope
    replacer: function (k, v) {
      // Handle root object case
      if (!k) return v;
      // Get the parent object that contains this key
      const parent = this as any;
      // Navigate to nested property

      if (parent[k] instanceof BigNumber) {
        return {
          __type: 'BigNumber',
          value: v,
        };
      }

      return v;
    },
  });
};
